var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5868_13124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5868_13124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16.3333V13.6667H11.3333V16.3333H2ZM2 11V8.33333H16.6667V11H2ZM2 5.66667V3H16.6667V5.66667H2ZM14 24.3333V20.2333L21.3667 12.9C21.5667 12.7 21.7889 12.5556 22.0333 12.4667C22.2778 12.3778 22.5222 12.3333 22.7667 12.3333C23.0333 12.3333 23.2889 12.3833 23.5333 12.4833C23.7778 12.5833 24 12.7333 24.2 12.9333L25.4333 14.1667C25.6111 14.3667 25.75 14.5889 25.85 14.8333C25.95 15.0778 26 15.3222 26 15.5667C26 15.8111 25.9556 16.0611 25.8667 16.3167C25.7778 16.5722 25.6333 16.8 25.4333 17L18.1 24.3333H14ZM16 22.3333H17.2667L21.3 18.2667L20.7 17.6333L20.0667 17.0333L16 21.0667V22.3333ZM20.7 17.6333L20.0667 17.0333L21.3 18.2667L20.7 17.6333Z",
    fill: "#2667B0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIconBlue);
export default __webpack_public_path__ + "static/media/draft_icon_blue.e8c8e9efddcd9d818a886b5fe5a6288c.svg";
export { ForwardRef as ReactComponent };